export default __webpack_public_path__ + "static/Plate_2x2_Coral_RGB-544aef12184c0215b6837a2caacb5436.svg";